import CustomerExperience from "./icons/CustomerExperience";
import Pricing from "./icons/Pricing";
import Features from "./icons/Features";
import Reputation from "./icons/Reputation";
import Clarity from "./icons/Clarity";
import ContentSharedComponent from "../contentShareComponent";
import Accordion from "@components/shared/newAccordion";
import { translate } from "@helpers/translationObjectFormatter";
import { TranslationsObject } from "@genericTypes/sharedTypes";
import { useQuery } from "@tanstack/react-query";

export default function MainContent() {
    const { data: translations } = useQuery<TranslationsObject>([
        "translations",
    ]);
    const whatWeDoList = [
        {
            id: "simplifyingComplex",
            title: translate(
                translations,
                "several_whatWeDo-simplifyingComplexTitle",
            ),
            description: [
                translate(
                    translations,
                    "several_whatWeDo-simplifyingComplexDescription1",
                ),
                translate(
                    translations,
                    "several_whatWeDo-simplifyingComplexDescription2",
                ),
            ],
        },
        {
            id: "transparency",
            title: translate(
                translations,
                "several_whatWeDo-simplifyingTransparencyTitle",
            ),
            description: [
                translate(
                    translations,
                    "several_whatWeDo-transparencyDescription",
                ),
            ],
        },
        {
            id: "reviewProcess",
            title: translate(translations, "several_whatWeDo-reviewProcess"),
            description: [
                translate(
                    translations,
                    "several_whatWeDo-reviewProcessDescription",
                ),
                translate(
                    translations,
                    "several_whatWeDo-reviewProcessDescription2",
                ),
            ],
        },
        {
            id: "expertiseResearch",
            title: translate(
                translations,
                "several_whatWeDo-expertiseResearch",
            ),
            description: [
                translate(
                    translations,
                    "several_whatWeDo-expertiseResearchDescription1",
                ),
                translate(
                    translations,
                    "several_whatWeDo-expertiseResearchDescription2",
                ),
            ],
        },
        {
            id: "partnerRelationships",
            title: translate(
                translations,
                "several_whatWeDo-partnerRelationshipsTiltle",
            ),
            description: [
                translate(
                    translations,
                    "several_whatWeDo-partnerRelationshipsDescription",
                ),
            ],
        },
        {
            id: "makeMoney",
            title: translate(translations, "several_whatWeDo-makeMoneyTitle"),
            description: [
                translate(
                    translations,
                    "several_whatWeDo-makeMoneyDescription1",
                ),
                translate(
                    translations,
                    "several_whatWeDo-makeMoneyDescription2",
                ),
            ],
        },
        {
            id: "userSatisfaction",
            title: translate(
                translations,
                "several_whatWeDo-userSatisfactionTitle",
            ),
            description: [
                translate(
                    translations,
                    "several_whatWeDo-userSatisfactionDescription1",
                ),
            ],
        },
        {
            id: "trustReliability",
            title: translate(
                translations,
                "several_whatWeDo-trustReliabilityTitle",
            ),
            description: [
                translate(
                    translations,
                    "several_whatWeDo-userSatisfactionDescription2",
                ),
            ],
        },
        {
            id: "ratingSystem",
            title: translate(
                translations,
                "several_whatWeDo-ratingSystemTitle",
            ),
            description: [
                translate(
                    translations,
                    "several_whatWeDo-ratingSystemDescription1",
                ),
                translate(
                    translations,
                    "several_whatWeDo-ratingSystemDescription2",
                ),
            ],
            list: [
                {
                    innerTitle: translate(
                        translations,
                        "several_whatWeDo-customerExperienceTitle",
                    ),
                    innerDescription: translate(
                        translations,
                        "several_whatWeDo-customerExperienceDescription",
                    ),
                    icon: <CustomerExperience />,
                },
                {
                    innerTitle: translate(
                        translations,
                        "several_whatWeDo-pricingTitle",
                    ),
                    innerDescription: translate(
                        translations,
                        "several_whatWeDo-pricingDescription",
                    ),
                    icon: <Pricing />,
                },
                {
                    innerTitle: translate(
                        translations,
                        "several_whatWeDo-featuresTitle",
                    ),
                    innerDescription: translate(
                        translations,
                        "several_whatWeDo-featuresDescription",
                    ),
                    icon: <Features />,
                },
                {
                    innerTitle: translate(
                        translations,
                        "several_whatWeDo-reputationTitle",
                    ),
                    innerDescription: translate(
                        translations,
                        "several_whatWeDo-reputationDescription",
                    ),
                    icon: <Reputation />,
                },
                {
                    innerTitle: translate(
                        translations,
                        "several_whatWeDo-clarityTitle",
                    ),
                    innerDescription: translate(
                        translations,
                        "several_whatWeDo-clarityDescription",
                    ),
                    icon: <Clarity />,
                },
            ],
            finalParagraph: translate(
                translations,
                "several_whatWeDo-ourAimIsDescription",
            ),
        },
    ];
    const FAQs = [
        {
            id: 1,
            title: translate(
                translations,
                "several_whatWeDoFaq-mileageRestrictionTitle",
            ),
            content: translate(
                translations,
                "several_whatWeDoFaq-mileageRestrictionDescription",
            ),
        },
        {
            id: 2,
            title: translate(
                translations,
                "several_whatWeDoFaq-productsOrServicesTitle",
            ),
            content: translate(
                translations,
                "several_whatWeDoFaq-productsOrServicesDescription",
            ),
        },
        {
            id: 3,
            title: translate(
                translations,
                "several_whatWeDoFaq-reviewsAndRatingsTitle",
            ),
            content: translate(
                translations,
                "several_whatWeDoFaq-reviewsAndRatingsDescription",
            ),
        },
        {
            id: 4,
            title: translate(
                translations,
                "several_whatWeDoFaq-companiesTrustworthyTitle",
            ),
            content: translate(
                translations,
                "several_whatWeDoFaq-companiesTrustworthyDescription",
            ),
        },
        {
            id: 5,
            title: translate(
                translations,
                "several_whatWeDoFaq-personalInformationSafeTitle",
            ),
            content: translate(
                translations,
                "several_whatWeDoFaq-personalInformationSafeDescription",
            ),
        },
        {
            id: 6,
            title: translate(
                translations,
                "several_whatWeDoFaq-chargesAssociatedTitle",
            ),
            content: translate(
                translations,
                "several_whatWeDoFaq-chargesAssociatedDescription",
            ),
        },
        {
            id: 7,
            title: translate(
                translations,
                "several_whatWeDoFaq-frequentlyWebsiteUpdatedTitle",
            ),
            content: translate(
                translations,
                "several_whatWeDoFaq-frequentlyWebsiteUpdatedDescription",
            ),
        },
        {
            id: 8,
            title: translate(
                translations,
                "several_whatWeDoFaq-differenceBetweenTitle",
            ),
            content: translate(
                translations,
                "several_whatWeDoFaq-differenceBetweenDescription",
            ),
        },
        {
            id: 9,
            title: translate(
                translations,
                "several_whatWeDoFaq-matchPeopleTitle",
            ),
            content: translate(
                translations,
                "several_whatWeDoFaq-matchPeopleDescription",
            ),
        },
        {
            id: 10,
            title: translate(
                translations,
                "several_whatWeDoFaq-privacyPolicyTitle",
            ),
            content: translate(
                translations,
                "several_whatWeDoFaq-privacyPolicyDescription",
            ),
        },
    ];
    return (
        <section className="lg:mt-16 mt-6 lg:mb-48 mb-24">
            <h1 className="font-bold lg:text-[40px] text-3xl lg:leading-10 leading-8 ml-4 lg:ml-9">
                {translate(translations, "several_whatWeDo-mainTitlePage")}
            </h1>
            <div className="lg:mt-14 mt-7">
                {whatWeDoList.map((mainItem, index) => (
                    <ContentSharedComponent key={index} mainItem={mainItem} />
                ))}
            </div>

            <div className="mt-24" id="faq">
                <Accordion title="FAQs" data={FAQs} />
            </div>
        </section>
    );
}
